/**
 * Dashboard "Send password recovery" always uses Site URL (`/`), not
 * `/reset-password`. The SPA must recognise recovery tokens on any path
 * and send them to the reset form before Home mounts over them.
 */
export function isRecoveryLocation({ search = '', hash = '' } = {}) {
  const hashParams = new URLSearchParams(String(hash).replace(/^#/, ''));
  const queryParams = new URLSearchParams(String(search).replace(/^\?/, ''));
  return hashParams.get('type') === 'recovery' || queryParams.get('type') === 'recovery';
}

export function resetPasswordLocation({ search = '', hash = '' } = {}) {
  const path = '/reset-password';
  const q = search && !search.startsWith('?') ? `?${search}` : search;
  const h = hash && !hash.startsWith('#') ? `#${hash}` : hash;
  return { pathname: path, search: q || '', hash: h || '' };
}
